import { useQuery } from "@tanstack/react-query"

import { getDoterChatLogs, getFlaggedChatSessions } from "./api"
import { QUERY_KEYS } from "../../constants"
import useFamilyUserSelectStore from "../../pages/family/hooks/useFamilyUserSelect"
import { FlagType } from "../../types"
import { useUserQuery } from "../queries"

export const useDoterChatLogsQuery = (date?: string) => {
  const { selectedUserId } = useFamilyUserSelectStore()

  return useQuery({
    queryKey: [QUERY_KEYS.DOTER_CHAT_LOGS, selectedUserId, date],
    queryFn: () => getDoterChatLogs({ childUserId: selectedUserId!, date }),
    enabled: !!selectedUserId,
  })
}

export const useFlaggedDoterChatLogsQuery = (flagType = FlagType.RED) => {
  const { selectedUserId } = useFamilyUserSelectStore()
  const { user } = useUserQuery()

  return useQuery({
    queryKey: [QUERY_KEYS.FLAGGED_DOTER_CHAT_LOGS, selectedUserId, flagType],
    queryFn: () => getFlaggedChatSessions(flagType),
    enabled: !!user,
  })
}
